import { UseQueryResult } from '@tanstack/react-query';
import i18next from 'i18next';
import { httpServices } from './httpServices';
const { get } = httpServices;

export interface IGetCountryCode {
  countryCode: string;
}

const GetLoggedCountryCode = ({
  hospitalSourceId,
}: {
  hospitalSourceId: string;
}): UseQueryResult<IGetCountryCode> => {
  return get({
    key: ['logged-country-code', hospitalSourceId, i18next.language],
    url: `${process.env.NEXT_PUBLIC_BASE_API_URL_SP}tenants/hospitals/${hospitalSourceId}/country-code`,
  }) as UseQueryResult<IGetCountryCode>;
};

const GetUnLoggedCountryCode = ({
  hospitalSourceId,
}: {
  hospitalSourceId: string;
}): UseQueryResult<IGetCountryCode> => {
  return get({
    key: ['unlogged-country-code', hospitalSourceId, i18next.language],
    url: `${process.env.NEXT_PUBLIC_BASE_API_URL_SP}user-not-logged/hospitals/${hospitalSourceId}/country-code`,
  }) as UseQueryResult<IGetCountryCode>;
};

export const tenantServices = {
  GetLoggedCountryCode,
  GetUnLoggedCountryCode,
};
